import { render, staticRenderFns } from "./DevProcessList.vue?vue&type=template&id=700c8ac4&scoped=true&"
import script from "./DevProcessList.vue?vue&type=script&lang=js&"
export * from "./DevProcessList.vue?vue&type=script&lang=js&"
import style0 from "./DevProcessList.vue?vue&type=style&index=0&id=700c8ac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700c8ac4",
  null
  
)

export default component.exports